<template>
  <b-overlay
    :show="__isOnLoad"
    variant="white"
    rounded
    opacity="0.70"
    spinner-variant="primary"
    spinner-small
    style="float: left; width: 100%;"
  >
  
    <div :class="styleSublisteMode+isCurrent(index === showList)" v-for="(item, index) in __list" :key="index" :style="" v-if="__idxOnEdition === -1 || __idxOnEdition === index">
      <div class="optionGroupCard">
        <div class="optionGroupCardTop">
          <div class="optionGroupCardInfo">
            <div class="optionGroupCardMeta">{{ item._id }}</div>
            <div class="optionGroupCardTitle">{{ item.name }}</div>
          </div>

          <div class="optionGroupCardActions" v-if="__idxOnEdition !== index && showMenu == index">
            <ico-btn size='p' type="simple" icone="gear-fill" :cb="()=>{dispatchEdit(item._id)}"></ico-btn>
            <ico-btn size='p' type="warning" icone="trash" :cb="()=>{dispatchDelete(item._id)}"></ico-btn>
            <ico-btn size='p' type="toggleOn" icone="reply-fill" :cb="()=>{toggleMenu(index)}"></ico-btn>
          </div>
          <div class="optionGroupCardActions" v-if="__idxOnEdition !== index && showMenu != index">
            <b-icon icon="list-stars" class="inlineOptionTrigger" aria-hidden="true" @click="toggleList(index)"></b-icon>
            <b-icon icon="gear-fill" class="inlineOptionTrigger" aria-hidden="true" @click="toggleMenu(index)"></b-icon>
          </div>
        </div>

        <div class="optionGroupCardBody" v-if="showList === index">
          <Opts :PID="item._id" :TYPE="item.type"></Opts>
        </div>
      </div>
    </div>

  </b-overlay>
</template>
<script>
import Opts from '@/pages/opts/index';

export default {
  components: {
    Opts,
  },
  props: {

    __idxOnEdition: {
      type: Number,
      default: () => {
        return -1;
      },
    },
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    __editMode: {
      type: Boolean,
      default: () => {
        return false;
      },
    },

  },
  
  data() {
    return {
      showMenu: -1,
      showList: -1,
    };
  },
  methods: {
    isCurrent(current) {
      if(this.showList !== -1) 
        return current ? '  actif' : ' flowted';
      return '';
    },

    toggleMenu(index) {
      if(this.showMenu != index ){this.showMenu = index} else {this.showMenu =-1}
    },

    toggleList(index) {
      if(this.showList != index ){this.showList = index} else {this.showList =-1}
    },

    dispatchEdit(idx) {
      this.$parent.editAction(idx);
    },


    dispatchDelete(idx) {
      this.$bvModal.msgBoxConfirm('Veuillez confirmer la suppression.', {
        title: 'Confirmation',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Confirmer',
        cancelTitle: 'Annuler',
        footerClass: 'p-2',
        hideHeaderClose: true,
        centered: false
      })
        .then(value => {
          if(value) {
            this.$parent.deleteAction(idx);
          }
        })
    },

    dispatchAdd() {
      this.$parent.addAction();
    },
  },
  watch: {
    __isOnLoad: function () {

    },
  },
  computed: {
    styleSublisteMode() {
      return (this.showList !== -1) ? 'listeMode' : 'listeMode';
    },
  },
  mounted() {

  }
};
</script>
<style scoped>
.listeMode {
    width: 100%;
    float: left;
    padding: 14px 16px;
    margin-bottom: 12px;
    border-radius: 18px;
    min-height: 48px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
    border: 1px solid #dbe4f0;
    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
    transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}
.listeMode .menu {
    float: right;
    border-radius: 10px;
    background-color: transparent;
}

.listeMode:hover {
  transform: translateY(-1px);
  border-color: #c9d8eb;
  box-shadow: 0 16px 32px rgba(15, 23, 42, 0.12);
}

.flowted {
    filter: blur(3.5px);
}

.actif {
    filter: none;
    background-color: #fff;
}

.optionGroupCard {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.optionGroupCardTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.optionGroupCardInfo {
  min-width: 0;
}

.optionGroupCardMeta {
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.35;
}

.optionGroupCardTitle {
  color: #1e2a44;
  font-size: 22px;
  font-weight: 800;
  line-height: 1.15;
}

.optionGroupCardActions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.optionGroupCardBody {
  padding-top: 8px;
}

@media (max-width: 767px) {
  .optionGroupCardTop {
    flex-direction: column;
    align-items: stretch;
  }

  .optionGroupCardActions {
    justify-content: flex-end;
  }
}
</style>
